import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ObfuscatedEmail from '@/components/base/ObfuscatedEmail';

const ContactCTA = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 px-6 md:px-10 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/5b61630997f5bbd6c1108ec6f47881db.jpg"
            alt="Nature fields"
            className="w-full h-72 md:h-80 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-stone-900/90 via-stone-900/70 to-stone-900/40"></div>
          <div className="absolute inset-0 flex flex-col items-start justify-center px-10 md:px-16">
            <span className="text-green-400 text-xs font-semibold uppercase tracking-[0.2em] mb-3">{t('cta_tag')}</span>
            <h2 className="text-white text-3xl md:text-4xl font-bold mb-4 max-w-lg leading-tight">
              {t('cta_title')}
            </h2>
            <p className="text-white/70 text-sm md:text-base mb-8 max-w-md leading-relaxed">
              {t('cta_desc')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="whitespace-nowrap cursor-pointer bg-green-600 hover:bg-green-700 text-white font-semibold px-7 py-3 rounded-md transition-colors duration-200 text-center"
              >
                {t('cta_btn')}
              </Link>
              <ObfuscatedEmail
                label="contact@Vixtra.ca"
                className="whitespace-nowrap border border-white/50 hover:border-white text-white font-semibold px-7 py-3 rounded-md transition-colors duration-200 text-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
